module.exports = __webpack_public_path__ + "img/抖动特效--分屏抖动gif.a0879967.gif";